import Grid2 from "@mui/material/Grid2";
import Skeleton from "@mui/material/Skeleton";
import { FC } from "react";

import { GAME_GRID_ITEM_SIZE } from "../data";
import { DEFAULT_SKELETON_COUNT, SKELETON_ASPECT_RATIO, SKELETON_BORDER_RADIUS } from "./data";
import { GameGridSkeletonProps } from "./type";

export const GameGridSkeleton: FC<GameGridSkeletonProps> = ({ count = DEFAULT_SKELETON_COUNT }) => (
  <Grid2 container columnSpacing={2} rowSpacing={{ xs: 1, sm: 2 }}>
    {[...Array(count)].map((_, index) => (
      <Grid2 key={`game-skeleton-${index}`} size={GAME_GRID_ITEM_SIZE}>
        <Skeleton
          variant="rectangular"
          sx={{
            borderRadius: SKELETON_BORDER_RADIUS,
            aspectRatio: SKELETON_ASPECT_RATIO,
            width: "100%",
            height: "100%",
          }}
          animation="wave"
        />
      </Grid2>
    ))}
  </Grid2>
);
